// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { subscribeStyles } from "@eisinc/Overrides/Widgets/Basic/Subscribe";
import { xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

subscribeStyles.mainGridContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

subscribeStyles.titleLabel = {
    variant: "h5",
    // xng-change - EIS-4193 - Update title to h3 to fix "heading elements are not in a sequentially-descending order"
    forwardAs: "h3",
    css: css`
        margin-bottom: 0;
    `,
};

subscribeStyles.emailGridItem = {
    css: css`
        display: flex;
        align-items: flex-start;
        gap: 8px;
        ${xScreen("lt", "sm")} {
            flex-direction: column;
        }
    `,
};

subscribeStyles.emailTextField = {};

subscribeStyles.emailButton = {
    css: css`
        max-width: 200px;
        background: transparent;
        ${xScreen("lt", "sm")} {
            max-width: 100%;
            width: 100%;
        }
    `,
};
